<style global>
@import 'filepond/dist/filepond.css';
@import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
</style>

<script>
import FilePond, { registerPlugin, supported } from 'svelte-filepond';

import { filesToAdd, loadingImages } from './store'

import firebase from "firebase/app";
import "@firebase/storage"
const storage = firebase.storage()

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFileValidateSize);

// a reference to the component, used to call FilePond methods
let pond;

let name = 'filepond';

// So this works and possibly returns the snapshot
const uploadImage = (file) => {
  console.log('called 2')
  $loadingImages = true
  const date = new Date()
  const fileToSend = file.file
  const fileName = date.getTime() + "-" + file.file.name

  var uploadTask = storage.ref().child(fileName).put(fileToSend)

  return uploadTask.then(snapshot => {    
    return snapshot.ref.getDownloadURL()
  })
}

// handle filepond events
function handleInit() {
	// console.log('FilePond has initialised');
}

function handleAddFile(err, fileItem) {
  if (fileItem.fileSize > 20971520) {
    console.log('ₕₐ ₜₕₐₜₛ ₐ ⱼₒₖₑ 𝒸ₒₘᵢₙ𝓰 𝒻ᵣₒₘ ᵧₒᵤ')
    return
  }

  uploadImage(fileItem).then(e => {
    $loadingImages = false
    const fileType = fileItem.file.type.split("/")[0]
    const fileName = fileItem.file.name
    const downloadURL = e
    $filesToAdd = [...$filesToAdd, {
      content: downloadURL,
      contentType: fileType,
      contentName: fileName
    }]
  })
}

function handleRemoveFile(err, fileItem) {
  const fileName = fileItem.file.name
  $filesToAdd = $filesToAdd.filter(item => item.contentName != fileName)

  console.log($filesToAdd)
}

function load(url, load, error, progress, abort, headers)  {
  fetch(url)
    .then(res => {
      res.blob().then(load)
    })
}

function process (fieldName, file, metadata, load, error, progress, abort) {
  uploadImage(file)
    .then(url => {
      load(url)
    })
}

</script>

<div class="app">

	<FilePond bind:this={pond} {name}
		server={ load, process }
    maxFileSize={'20MB'}
    labelMaxFileSizeExceeded={"This file is too large"}
    labelMaxFileSize={"Max file size is 20MB"}
		allowMultiple={true}
    allowReorder={false}
		oninit={handleInit}
    onremovefile={handleRemoveFile}
		onaddfile={handleAddFile}/>
</div>
